<div class="pink-title" [ngClass]="customClass">
	<i class="icon-{{ icon }}" *ngIf="icon"></i>
	<p>{{ label }}</p>
</div>
